import { render, staticRenderFns } from "./AttrGroupsSelectionDialog.vue?vue&type=template&id=88ff22ea"
import script from "./AttrGroupsSelectionDialog.vue?vue&type=script&lang=js"
export * from "./AttrGroupsSelectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports